<template>
  <div>  
    <b-modal id="modal_login" size="md" title="Acceso / Login"
        hide-header ok-only content-class="shadow"
        button-size="sm" centered ok-title="Cancelar" ok-variant="outline-secondary">

        <login/> 

    </b-modal>
  </div>
</template>

<script>

import login from '@/views/Login.vue'

export default {
  name: 'loginM',
  components: {
    login,

  },
  data() {
    return {      
    }
  },
  created() {
    // if (this.logueado) {
    //   this.$router.push('/');    
    // }
  },
  computed: {
  },
  methods: {
      close() {
          this.hideModal();    
          //this.$bvModal.hide(this.modal);
      },
  }
}
</script>
